import { useEffect, useState } from 'react';

type LogoVariant = 'default' | 'light';

const LOGO_SRC: Record<LogoVariant, string> = {
  default: '/logo.png',
  light: '/logo_blanc.png',
};

export default function AnimatedLogo() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className={`relative transition-all duration-1000 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}>
      <img
        src={LOGO_SRC.default}
        alt="L Benna Production"
        className="h-28 sm:h-32 md:h-40 object-contain object-top drop-shadow-2xl"
      />
    </div>
  );
}

/** Header = fond clair (logo.png) · Footer = fond sombre (logo_blanc.png) */
export function CompactLogo({ variant = 'default' }: { variant?: LogoVariant }) {
  return (
    <div className="flex items-center gap-2 group cursor-pointer">
      <img
        src={LOGO_SRC[variant]}
        alt="L Benna Production"
        className="h-10 md:h-12 w-auto object-contain group-hover:scale-105 transition-transform"
      />
    </div>
  );
}
